<script setup>
// §8.1 PageHeader — eyebrow + title + subtitle, actions right.
// Eyebrow is Inter 11/600, 1.8px tracking, uppercase, accent-text (§5, §3.2).
// Title is Poppins 25/600 (never below 15px, D8). Sentence case (§9).
defineProps({
	eyebrow: { type: String, default: null },
	title: { type: String, required: true },
	subtitle: { type: String, default: null },
})
</script>

<template>
	<header class="l-pageheader">
		<div class="lede">
			<div v-if="eyebrow" class="eyebrow">{{ eyebrow }}</div>

			<!-- <h2 class="title">{{ title }}</h2> -->
			<h2 class="title" v-html="title"></h2>
			
			<p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
		</div>
		<div v-if="$slots.actions" class="actions">
			<slot name="actions" />
		</div>
	</header>
</template>

<style scoped>
.l-pageheader
{
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: var(--sp-5);
	margin-bottom: var(--sp-6);
}

.eyebrow
{
	font-size: var(--text-eyebrow);
	font-weight: 600;
	letter-spacing: 1.8px;
	text-transform: uppercase;
	color: var(--accent-text);
	margin-bottom: 5px;
}

.title
{
	font-family: var(--font-display);
	font-size: var(--text-title);
	font-weight: 600;
	letter-spacing: -0.01em;
	color: var(--text);
}

.subtitle
{
	font-size: var(--text-nav);
	color: var(--text-3);
	margin-top: 3px;
}

.actions
{
	display: flex;
	align-items: center;
	gap: var(--sp-2);
	flex: none;
}
</style>
